import { render } from "./AdminAttendanceRecordPage.vue?vue&type=template&id=4fb5e226"
import script from "./AdminAttendanceRecordPage.vue?vue&type=script&lang=js"
export * from "./AdminAttendanceRecordPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__